import * as R from 'ramda';
import React, { useMemo } from 'react';
import { pure } from 'react-recompose';
// forms
import { Fieldset2 } from '../../forms';
// helpers/constants
import * as G from '../../helpers';
// feature rate
import { FormSection } from './ui';
import { disableDriverField } from './helpers';
import { generalServiceVendorSectionSettings } from './settings';
import {
  chassisFields,
  generalDMSectionFields,
  getDriverSectionSettings,
  getPointLocationSettings,
} from './driver/settings';
//////////////////////////////////////////////////

const fieldsWrapperStyles = { mt: 20, flexDirection: 'column' };

export const GeneralSectionForTel = pure((props) => {
  const { optionsForSelect, handleCustomChange, isCarrierWithCreationPermission } = props;

  const mappedFields = useMemo(
    () => R.map(R.map(R.assoc('disabled', isCarrierWithCreationPermission)), generalDMSectionFields),
    [isCarrierWithCreationPermission],
  );

  return (
    <FormSection mt={20} px={20}>
      {mappedFields.map((fields, index) => (
        <Fieldset2
          {...G.getFormikProps(props)}
          {...optionsForSelect}
          key={index}
          fields={fields}
          handleCustomChange={handleCustomChange}
          fieldsWrapperStyles={{
            flexGrow: 1,
            mb: G.ifElse(R.equals(index, R.dec(R.length(generalDMSectionFields))), 0, 25),
          }}
        />
      ))}
    </FormSection>
  );
});

export const GeneralSectionForServiceVendor = pure((props) => {
  const { optionsForSelect } = props;

  return (
    <Fieldset2
      {...optionsForSelect}
      {...G.getFormikProps(props)}
      fieldsWrapperStyles={{ mt: 25, px: 20 }}
      fields={generalServiceVendorSectionSettings}
    />
  );
});

export const DriverSection = pure((props) => {
  const { optionsForSelect, handleCustomChange } = props;

  return (
    <FormSection mt={20} justifyContent='space-around'>
      {getDriverSectionSettings(props).map(({ fields }, index) => (
        <Fieldset2
          {...optionsForSelect}
          {...G.getFormikProps(props)}
          key={index}
          fields={fields}
          handleCustomChange={handleCustomChange}
          fieldsWrapperStyles={fieldsWrapperStyles}
        />
      ))}
      {
        G.getShowChassisSectionConfigFromWindow() &&
        <Fieldset2
          {...G.getFormikProps(props)}
          fields={chassisFields}
          fieldsWrapperStyles={fieldsWrapperStyles}
        />
      }
    </FormSection>
  );
});

export const EditDriverSection = pure((props) => {
  const { optionsForSelect, handleCustomChange } = props;

  return (
    <FormSection mt={20} justifyContent='space-around'>
      {getDriverSectionSettings(props).map(({ fields }, index) => {
        const fieldsToUse = R.map((field) => disableDriverField(field, props), fields);

        return (
          <Fieldset2
            {...optionsForSelect}
            {...G.getFormikProps(props)}
            key={index}
            fields={fieldsToUse}
            handleCustomChange={handleCustomChange}
            fieldsWrapperStyles={fieldsWrapperStyles}
          />
        );
      })}
      {
        G.getShowChassisSectionConfigFromWindow() &&
        <Fieldset2
          {...G.getFormikProps(props)}
          fields={chassisFields}
          fieldsWrapperStyles={fieldsWrapperStyles}
        />
      }
    </FormSection>
  );
});

export const PointsSection = pure((props) => {
  const { handleSelectLocation, handleChangeSelectLocation } = props;

  return (
    <Fieldset2
      {...G.getFormikProps(props)}
      fields={getPointLocationSettings(props)}
      customSelectLocationFunction={handleSelectLocation}
      handlers={{ customHandleChange: handleChangeSelectLocation }}
      fieldsWrapperStyles={{ mt: 25, justifyContent: 'space-around' }}
    />
  );
});

export const ChassisSection = pure((props) => (
  <Fieldset2
    {...G.getFormikProps(props)}
    fields={chassisFields}
    fieldsWrapperStyles={{ mt: 20, justifyContent: 'space-around' }}
  />
));
